<template>
	<div
		ref="window"
		:class="[
			'c-window',
			dockPos,
			{ test: testMode === true },
			{ loaded: loaded === true },
			{ active: dashboardActive === true },
			{ dock: dock === true },
			{ move: isMoving },
		]"
		:style="style"
	>
		<div class="c-window__header">
			<div
				class="c-window__header__draggable"
				@mousedown.prevent="onMousedown"
			></div>
			<svg
				class="c-window__logo img-fluid"
				width="224"
				height="224"
				viewBox="0 0 224 224"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clip-path="url(#clip0)">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M152.688 216.38C194.427 200.098 224 159.503 224 112C224 50.1441 173.856 0 112 0C50.1441 0 0 50.1441 0 112C0 158.501 28.3385 198.383 68.6875 215.318V173.25L82.6875 140V126H89.6875V88.6667C89.6875 78.3574 99.0895 70 110.688 70C122.285 70 131.688 78.3574 131.688 88.6667V126H138.688V140L152.688 173.25V216.38Z"
						fill="url(#paint0_linear)"
					/>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M124.688 223.426V180.737C129.557 179.748 134.242 178.255 138.688 176.312V220.938C134.124 222.053 129.451 222.889 124.688 223.426ZM124.688 224.137V224.137H138.688V224.137H124.688Z"
						fill="#F5295C"
					/>
				</g>
				<defs>
					<linearGradient
						id="paint0_linear"
						x1="112"
						y1="0"
						x2="112"
						y2="216.38"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#FF537E" />
						<stop offset="1" stop-color="#F5295C" />
					</linearGradient>
					<clipPath id="clip0">
						<rect width="224" height="224" fill="white" />
					</clipPath>
				</defs>
			</svg>

			<!-- <img class="c-window__logo img-fluid" src="/icons/128.png" /> -->
			<span
				class="c-window__btn close dock"
				tabindex="1"
				@click="onDock"
				:title="dockTitle"
			>
				<minimize-2-icon v-if="dock" size="1.25x"></minimize-2-icon>
				<corner-up-right-icon v-else size="1.25x"></corner-up-right-icon>
			</span>
			<span
				class="c-window__btn close"
				tabindex="1"
				@click="onClose"
				title="Close the dashboard. Press alt+W to open it again"
			>
				<x-icon size="1.25x" class=""></x-icon>
			</span>
		</div>
		<div class="c-window__body">
			<iframe ref="iframe" @load="onLoad" :src="url" name="app"></iframe>
		</div>
	</div>
</template>

<script>
import {
	XIcon,
	MoveIcon,
	CornerUpRightIcon,
	Minimize2Icon,
} from 'vue-feather-icons';
export default {
	components: {
		XIcon,
		MoveIcon,
		CornerUpRightIcon,
		Minimize2Icon,
	},
	data: function () {
		return {
			dock: false,
			active: false,
			isMoving: false,
			wx: 10,
			wy: 10,
			owx: 0,
			owy: 0,
			mx: 0,
			my: 0,
			width: 400,
			height: 564,
			dockPos: 'left',
			loaded: false,
		};
	},
	props: {
		testMode: Boolean,
	},
	watch: {
		dock: function () {
			if (this.dock) {
				this.wy = 0;
				if (this.dockPos === 'right') {
					this.wx = this.elWidth - this.width;
				} else {
					this.wx = 0;
				}
				this.shiftPage();
			} else {
				this.wx = 10;
				this.wy = 10;
				if (this.dockPos === 'right') {
					this.wx = this.elHeight - this.width - 10;
				} else {
					this.wx = 10;
				}
				this.unshiftPage();
			}
		},
		dashboardActive: {
			handler: function () {
				if (this.dashboardActive) {
					this.active = true;
				} else {
					this.active = false;
				}
			},
			immediate: true,
		},
	},
	computed: {
		url: function () {
			if (process.env.NODE_ENV === 'production') {
				return 'https://app.underlineme.com';
			} else {
				return 'http://localhost:8080';
			}
		},
		el: function () {
			if (this.testMode) {
				return this.$refs.window.parentElement;
			} else {
				return document.body;
			}
		},
		elWidth: function () {
			return this.el.clientWidth;
		},
		elHeight: function () {
			return this.el.clientHeight;
		},
		dashboardActive: function () {
			return this.$store.getters['ui/dashboard'];
		},
		style: function () {
			let transform = `transform:translate(${this.wx}px, ${this.wy}px)`;
			return transform;
		},
		dockTitle: function () {
			if (this.dock) {
				return `Minimize dashboard`;
			} else {
				return `Pin dashboard to the ${this.dockPos} side`;
			}
		},
	},
	methods: {
		shiftPage: function () {
			if (this.testMode) {
				return;
			}
			document
				.getElementsByTagName('html')[0]
				.setAttribute(
					'style',
					`margin-left:${this.width}px;width:calc(100% - ${this.width}px);`
				);
		},
		unshiftPage: function () {
			if (this.testMode) {
				return;
			}
			document.getElementsByTagName('html')[0].setAttribute('style', ``);
		},
		onDock: function () {
			this.dock = !this.dock;
		},
		onClose: function () {
			this.$store.dispatch('ui/closeDashboard');
		},
		onLoad: function () {
			this.loaded = true;
			// window.frames.app.postMessage(
			// 	JSON.stringify({
			// 		type: 'init',
			// 	})
			// );
			console.log('attempting login');
			this.$refs.iframe.contentWindow.postMessage(
				JSON.stringify({
					type: 'login',
					token: this.$store.getters['user/token'],
				})
			);
		},
		setGrid: function (x, y, ex, ey) {
			if (x < 10) {
				x = 0;
			}
			if (y < 10) {
				y = 0;
			}
			if (x + this.width + 10 > this.elWidth) {
				x = this.elWidth - this.width;
			}
			if (y + this.height + 10 > this.elHeight) {
				y = this.elHeight - this.height;
			}
			this.wx = x;
			this.wy = y;
		},
		onMousedown: function (e) {
			if (this.dock) {
				return;
			}
			this.mx = e.clientX || e.touches[0].clientX;
			this.my = e.clientY || e.touches[0].clientY;

			this.isMoving = true;
		},
		onMouseMove: function (e) {
			if (this.isMoving) {
				let clientX = e.clientX || e.touches[0].clientX;
				let clientY = e.clientY || e.touches[0].clientY;
				let x = clientX - this.mx;
				let y = clientY - this.my;
				let tempx = this.owx + x;
				let tempy = this.owy + y;

				this.setGrid(tempx, tempy, clientX, clientY);
				// if (this.wx * 2 > this.elWidth / 2) {
				// 	this.dockPos = 'right';
				// } else {
				// 	this.dockPos = 'left';
				// }
			}
		},
		onMouseUp: function (e) {
			this.isMoving = false;
			this.owx = this.wx;
			this.owy = this.wy;
		},
		registerEventHandlers: function () {
			window.addEventListener('mouseup', this.onMouseUp);
			window.addEventListener('mousemove', this.onMouseMove);
		},
		removeEventHandlers: function () {
			window.removeEventListener('mouseup', this.onMouseUp);
			window.removeEventListener('mousemove', this.onMouseMove);
		},
	},
	mounted: function () {
		this.registerEventHandlers();
	},
	beforeDestroy: function () {
		this.removeEventHandlers();
	},
};
</script>

<style lang="scss">
.c-window {
	display: flex;
	flex-direction: column;
	position: fixed;
	z-index: 999999;
	top: 0;
	left: 0;
	width: 400px;
	height: 564px;
	background-color: var(--g1);
	border-radius: var(--border-radius);
	overflow: hidden;
	box-shadow: 0 1.3px 6.5px -4px rgba(0, 0, 0, 0.066),
		0 3.2px 13.1px -4px rgba(0, 0, 0, 0.11),
		0 6.1px 20.8px -4px rgba(0, 0, 0, 0.164),
		0 10px 30px -4px rgba(0, 0, 0, 0.26);
	opacity: 0;
	pointer-events: none;

	&.test {
		position: absolute;
	}

	&.active {
		opacity: 1;
		pointer-events: all;
	}

	&__header {
		position: relative;
		padding: var(--margin);
		display: flex;
		align-items: center;
		justify-content: flex-end;
		height: var(--spacer-lg);
		user-select: none;

		&__draggable {
			position: absolute;
			top: 0;
			left: 0;
			width: calc(100% - 70px);
			height: 100%;
		}
	}

	&:not(.dock) {
		.c-window__header {
			&__draggable {
				cursor: move;
			}
		}
	}

	&__body {
		height: 100%;
		iframe {
			width: 100%;
			height: 100%;
			border: none;
		}
	}

	&__logo {
		margin-right: auto;
		width: var(--spacer);
		height: var(--spacer);
	}

	&__btn {
		&.dock {
			transform: scaleX(-1); //rotate(180deg);
		}

		&:focus {
			outline: none;
		}
	}

	&.move {
		.c-window__body {
			pointer-events: none;
		}
	}

	&.dock {
		height: 100%;
		border-radius: 0;

		// .c-window__btn {
		// 	&.dock {
		// 		transform: rotate(0);
		// 	}
		// }
	}

	&.right {
		.c-window__btn {
			&.dock {
				transform: rotate(0);
			}
		}
	}
}
</style>